module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/info-circle-191aed1e7e0256850998f53979f1eeff.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/info-circle.svg
// module id = AKXi
// module chunks = 24